import { translateDetail, translateStore, translateEdit } from './request';
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    isEdit: {
      type: [Boolean, Number, String],
      default: false,
      required: true
    }
  },
  data() {
    return {
      addForm: {
        signName: '',
        zh: '',
        cht: '',
        en: '',
        spa: '',
        fra: '',
        ru: ''
      }
    };
  },
  watch: {
    visible(newV) {
      if (newV && this.$props.isEdit) {
        this.getDetail();
      }
    }
  },
  computed: {
    ADD_RULES() {
      return {
        signName: [{
          required: true,
          message: this.$t('请输入') + this.$t('标签名称'),
          trigger: 'blur'
        }]
      };
    }
  },
  created() {},
  methods: {
    closeAddVisible(e) {
      this.$emit('cancel', e);
      this.resetForm();
    },
    resetForm() {
      this.addForm.signName = '';
      this.addForm.zh = '';
      this.addForm.cht = '';
      this.addForm.en = '';
      this.addForm.spa = '';
      this.addForm.fra = '';
      this.addForm.ru = '';
      this.$refs.addFormRef.resetFields();
    },
    async getDetail() {
      const res = await translateDetail({
        signId: this.$props.isEdit
      });
      this.addForm = res;
      this.addForm.signId = res.id;
    },
    saveAdd() {
      this.$refs.addFormRef.validate(async valid => {
        if (valid) {
          if (this.$props.isEdit) {
            await translateEdit(this.addForm);
          } else {
            await translateStore(this.addForm);
          }
          this.$emit('save');
          this.closeAddVisible();
        }
      });
    }
  }
};